module.exports = __webpack_public_path__ + "img/ar2021_icon-service.711fb0ed.png";